import React, { useContext, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HOST } from "../constants/HostConstants";
import { AlertContext } from "../context/MainContext";

const ForgotPasswordModal = ({ setModal }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { setAlert } = useContext(AlertContext);

  const handleSubmit = async () => {
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      setAlert([
        "Sending Password",
        "Please wait while we process your request.",
        "waiting",
      ]);
      const response = await fetch(`${HOST}/api/user/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email_address: email }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { error: text };
      }

      if (response.ok) {
        setMessage(data.message || "Password sent to your email!");
        setAlert([
          "Email Sent",
          "Please check your inbox for your password.",
          "confirm",
        ]);
        setTimeout(() => setModal(false), 3000);
      } else {
        setError(data.error || "Something went wrong. Please try again.");
        setAlert([
          "Request Failed",
          data.error || "Something went wrong. Please try again.",
          "failed",
        ]);
      }
    } catch (err) {
      setError("Failed to send request. Please try again.");
      setAlert([
        "Request Failed",
        "Failed to send request. Please try again.",
        "failed",
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 relative">
        <button
          onClick={() => setModal(false)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <AiOutlineClose size={24} />
        </button>

        <h2 className="text-2xl font-bold mb-4">Forgot Password?</h2>
        <p className="text-gray-600 mb-6">
          Enter your email address and we'll send your password to your inbox.
        </p>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              className="bg-slate-200 px-4 py-2 rounded"
              disabled={loading}
            />
          </div>

          {error && <p className="text-red-500 text-sm text-center">{error}</p>}

          {message && (
            <p className="text-green-500 text-sm text-center">{message}</p>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-black text-white px-4 py-2 rounded hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Sending..." : "Send Password"}
          </button>

          <button
            onClick={() => setModal(false)}
            className="text-gray-600 hover:text-gray-800 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
